import {FC} from 'react';
import {PAYMENT_METHOD_ICONS} from '../../model/paymentMethodIcons';
import type {ProfilePaymentMethod} from '../../model/paymentMethod';
import styles from './PaymentMethodOption.module.css';

type Props = {
	value: ProfilePaymentMethod;
	label: string;
	onSelect: (value: ProfilePaymentMethod) => void;
};

export const PaymentMethodOption: FC<Props> = ({value, label, onSelect}) => {
	const Icon = PAYMENT_METHOD_ICONS[value];

	return (
		<button type="button" className={styles.row} onClick={() => onSelect(value)}>
			<span className={styles.iconWrap}>
				<Icon className={styles.icon} />
			</span>
			<span className={styles.label}>{label}</span>
		</button>
	);
};
